import { defineStore } from 'pinia'

export const useSearchGlobalStore = defineStore('SearchGlobal', {
  state: () => ({
    search: '',
    members: <SearchUser[]>[],
    products: <SearchProduct[]>[],
    categories: <SearchCategory[]>[],
    promos: <SearchPromo[]>[],
    vouchers: <SearchVoucher[]>[],
    orders: <SearchOrder[]>[],
    loading: false,
  }),

  actions: {

  },
})
